export enum ReservationOfferChannel {
  phoneCall = 'phoneCall',
  text = 'text',
}
